// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blocked-cities .sk-select__typing-input,\n.blocked-cities .sk-select__typing-input:focus {\n  top: auto;\n  bottom: 0;\n  width: 100%;\n  pointer-events: none;\n}\n.blocked-cities .is-opened .sk-select__typing-input {\n  pointer-events: initial;\n}\n", ""]);
// Exports
module.exports = exports;
